/** Skill fit bands aligned with public Check fit (≥75 strong, ≥45 partial). */
export const RECOMMENDATION_FIT_STRONG_MIN = 75;
export const RECOMMENDATION_FIT_PARTIAL_MIN = 45;

export type RecommendationFitBand = 'STRONG' | 'PARTIAL' | 'WEAK';

export const recommendationFitLabel: Record<RecommendationFitBand, string> = {
  STRONG: 'Strong fit',
  PARTIAL: 'Partial fit',
  WEAK: 'Weak fit',
};

export const recommendationFitTagColor: Record<RecommendationFitBand, string> =
  {
    STRONG: 'success',
    PARTIAL: 'warning',
    WEAK: 'error',
  };

/** Ant Design token keys for progress stroke by fit band. */
export const recommendationFitProgressToken: Record<
  RecommendationFitBand,
  'colorSuccess' | 'colorWarning' | 'colorError'
> = {
  STRONG: 'colorSuccess',
  PARTIAL: 'colorWarning',
  WEAK: 'colorError',
};

export function recommendationFitBand(
  score?: number | null
): RecommendationFitBand | null {
  if (score == null || Number.isNaN(score)) {
    return null;
  }
  if (score >= RECOMMENDATION_FIT_STRONG_MIN) {
    return 'STRONG';
  }
  if (score >= RECOMMENDATION_FIT_PARTIAL_MIN) {
    return 'PARTIAL';
  }
  return 'WEAK';
}

export function resolveRecommendationFitScore(
  relevance?: number | null,
  matchedSkillCount?: number | null,
  totalJobSkills?: number | null,
  aiBriefScore = false
): number | null {
  if (aiBriefScore && relevance != null && !Number.isNaN(relevance)) {
    return Math.round(relevance * 10) / 10;
  }
  if (totalJobSkills && totalJobSkills > 0 && matchedSkillCount != null) {
    return Math.round((matchedSkillCount / totalJobSkills) * 1000) / 10;
  }
  if (relevance == null || Number.isNaN(relevance)) {
    return null;
  }
  return Math.round(relevance * 10) / 10;
}

export function formatRecommendationFitScore(
  relevance?: number | null,
  matchedSkillCount?: number | null,
  totalJobSkills?: number | null
): string {
  const score = resolveRecommendationFitScore(
    relevance,
    matchedSkillCount,
    totalJobSkills,
    false
  );
  if (score == null) {
    return '—';
  }
  const band = recommendationFitBand(score);
  return band ? `${score}% · ${recommendationFitLabel[band]}` : `${score}%`;
}

export function formatSkillOverlap(
  matchedSkillCount?: number | null,
  totalJobSkills?: number | null
): string {
  if (!totalJobSkills || matchedSkillCount == null) {
    return '';
  }
  return `${matchedSkillCount} of ${totalJobSkills} job skills`;
}
